module.exports = __webpack_public_path__ + "static/media/400069_01.4e8a2130.png";